import { render, staticRenderFns } from "./MenuPublic.vue?vue&type=template&id=67c7138c"
import script from "./MenuPublic.vue?vue&type=script&lang=js"
export * from "./MenuPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports